import { useState, useEffect } from 'preact/hooks'
import { emitterProps, globalEmitter } from 'helpers/emitter-event'
import { addCartItem, getCart, getMaxQuantityByVariant } from 'libs/cart'
import { openModal } from 'helpers/dom'
import Icon from 'snippets/icon/icon'

const selectors = {
  MODAL_ID: 'back-in-stock'
}

function ProductCardButton({ url, id, type, variant, className = '' }) {
  const [isAdding, setIsAdding] = useState(false)
  const [maxQuantity, setMaxQuantity] = useState(null)
  const [cartItems, setCartItems] = useState(GM_STATE.cart.initCart.items)

  const activeBackground = 'bg-accent-1 hover:bg-accent-2'
  const disabledBackground = 'bg-grey-400 hover:bg-grey-500'
  const classButton =
    'w-full flex min-h-10 cursor-pointer items-center justify-center rounded-none px-2 pt-[7px] pb-[9px] text-sm font-bold text-white transition-colors duration-300 ease-in-out text-grey-900 md:px-3 md:pt-[11px] md:pb-[13px]'

  const getMaxQuantity = async (variant) => {
    const cartData = await getCart()

    setCartItems(cartData.items)

    return getMaxQuantityByVariant(cartData.items, variant)
  }

  const syncMaxQuantity = async () => {
    const maxValue = await getMaxQuantity(variant)

    setMaxQuantity(maxValue)
  }

  const updateMaxQuantity = (items) => {
    const maxValue = getMaxQuantityByVariant(items, variant)

    setCartItems(items)
    setMaxQuantity(maxValue)
  }

  const addToCart = async () => {
    setIsAdding(true)

    try {
      const response = await addCartItem(variant.id, {}, 1)

      if (response) {
        const newCart = await getCart()

        globalEmitter.emit(emitterProps.cart.add, {
          cart: newCart,
          data: response
        })
        await syncMaxQuantity()
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
    } finally {
      setIsAdding(false)
    }
  }

  const cartUpdateListener = (items) => updateMaxQuantity(items, variant)

  const handleBackInStock = () => {
    globalEmitter.emit(emitterProps.product.notify, {
      variantId: variant.id,
      id
    })
  }

  useEffect(() => {
    if (variant) {
      updateMaxQuantity(cartItems, variant)
      globalEmitter.on(emitterProps.cart.update, cartUpdateListener)
    }

    return () => {
      globalEmitter.off(emitterProps.cart.update, cartUpdateListener)
    }
  }, [variant])

  return type === 'add' ? (
    variant.available && maxQuantity > 0 ? (
      <button
        type="button"
        onClick={addToCart}
        className={`${classButton} ${isAdding && 'pointer-events-none'} ${variant.available && maxQuantity > 0 ? activeBackground : disabledBackground} ${className}`}
      >
        {variant.available && maxQuantity > 0 ? `${isAdding ? 'Adding' : 'Add'} to Cart` : 'Sold Out'}
      </button>
    ) : (
      <button type="button" title="Notify Me" onClick={handleBackInStock} className={`${classButton} ${disabledBackground} ${className}`}>
        <Icon name="icon-bell" viewBox="0 0 21 20" className="mr-2 size-4 md:size-5" />
        Notify Me
      </button>
    )
  ) : (
    <a href={url} className={`${classButton} ${activeBackground} ${className}`}>
      View Options
    </a>
  )
}

export default ProductCardButton
